import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9630792a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "疫情防控",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'courier')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(record.courier.name), 1))
          : _createCommentVNode("", true),
        (column.key === 'street_name')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.extra.street_name), 1))
          : _createCommentVNode("", true),
        (column.key === 'type')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.type == 1 ? "昆明健康宝" : "社区报备"), 1))
          : _createCommentVNode("", true),
        (column.key === 'images')
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(record.images, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_image, {
                key: index,
                src: item,
                style: {"width":"50px"}
              }, null, 8, ["src"]))
            }), 128))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ], 64))
}